export default __webpack_public_path__ + "static/media/2627 spice rack side.8a2c7493.png";